/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".field-container span{font-weight:700}div.field-container{margin-bottom:1.5rem}label{font-weight:700;margin:0;width:150px}.alert{max-width:400px;z-index:0}.buffer-radio-multi{padding-right:20px}.sketch-picker{position:absolute;z-index:99999}#color:hover,#outline-color:hover{cursor:pointer}#distance,mc-color-picker-ng,mc-select-ng,select{width:225px!important}.field-container{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;position:relative}"];
export { styles as styles };
